declare let window: any;
import { computed, nextTick } from 'vue';
import type { RouteLocationNormalized } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import { defineUserStore } from '@/stores/user';
import {useUnderlingAndDistrictCN} from '@/hooks/useUnderlingAndDistrictCN';
// import {routesModule} from '@/stores/permission';
import Login from '../views/login/index.vue'

export interface RouteItem {
    path: string;
    name?: string;
    redirect?: string;
    icon?: string;
    hidden?: boolean;
    children?: ChildrenItem[];
    component?: Object;
    meta?: Object
}
export interface ChildrenItem {
    path: string;
    name: string;
    icon: string;
    component?: object;
    hidden?: boolean;
    redirect?: string;
    children?: ChildrenItem[];
    meta?: Object
}
// 根级目录添加redirect可保证面包屑根目录点击可正常跳转
// 子路由path不需加/，el-menu-item中已做拼接
export const routes: RouteItem[] = [
    {
        path: '/',
        redirect: '/lead/list',
        hidden: true
    },
    {
        path: '/login',
        component: Login,
        meta: {
            showNav: true
        },
        hidden: true
    },
    {
        path: '/weekly',
        component: () => import('@/views/weekly/index.vue'),
        meta: {
            showNav: true
        },
        hidden: true
    },
    {
        path: '/dashboard',
        name: 'menu.dashboard',
        icon: 'menu-dashboard-icon',
        component: () => import('@/views/dashboard/index.vue'),
    },
    //线索
    {
        path: '/lead',
        name: 'menu.lead',
        redirect: '/lead/list',
        icon: 'menu-lead-icon',
        children: [
            // 列表
            
            // {
            //     path: 'list',
            //     name: 'menu.leadList',
            //     component: () => import('@/views/leadManagement/index.vue'),
            //     icon: 'incomeAnalysis'
            // },
            {
                path: 'list',
                name: 'menu.leadManagement',
                component: () => import('@/views/leadManagement/clueList/index.vue'),
                icon: 'incomeAnalysis'
            },
            {
                path: 'pool',
                name: 'menu.leadPool',
                component: () => import('@/views/leadManagement/leadPool/index.vue'),
                icon: 'boostodoStatistic'
            }
        ]
    },
    // 客户
    {
        path: '/accounts',
        name: 'menu.accounts',
        redirect: '/accounts/management',
        icon: 'menu-customer-icon',
        children: [
            // 客户管理
            {
                path: 'management',
                name: 'menu.accountsManagement',
                component: () => import('@/views/accounts/accountsManagement/index.vue'),
                icon: 'customerMarket',
            },
            // 公海
            {
                path: 'pool',
                name: 'menu.publicData',
                component: () => import('@/views/accounts/accountsPool/index.vue'),
                icon: 'customerMarket',
            }
        ]
    },
    // 联系人管理
    {
        path: '/contact',
        name: 'menu.contactList',
        redirect: '/contact/list',
        icon: 'menu-contact-icon',
        children: [
            // 列表
            {
                path: 'list',
                name: 'menu.contactManagement',
                component: () => import('@/views/contactManagement/index.vue'),
                icon: 'customerMarket',
            }
        ]
    },
    // 商机管理
    {
        path: '/business',
        name: 'menu.business',
        redirect: '/business/list',
        icon: 'menu-business-icon',
        children: [
            {
                path: 'list',
                name: 'menu.businessManagement',
                component: () => import('@/views/business/index.vue'),
                icon: 'customerMarket',
            }
        ]
    },
    // // 标签管理
    // {
    //     path: '/label',
    //     name: 'menu.label',
    //     icon: 'menu-tag-icon',
    //     component: () => import('@/views/other.vue'),
    // },
    // 业绩分析
    {
        path: '/analysis',
        name: 'menu.analysis',
        redirect: '/analysis/analysis',
        icon: 'menu-analysis-icon',
        children: [
            {
                path: 'lead',
                name: 'menu.leadAnalysis',
                component: () => import('@/views/dataAnalysis/leadAnalysis/index.vue'),
                icon: 'customerMarket',
            },
            {
                path: 'account',
                name: 'menu.accountAnalysis',
                component: () => import('@/views/dataAnalysis/accountAnalysis/index.vue'),
                icon: 'customerMarket',
            },
            {
                path: 'oppty',
                name: 'menu.businessAnalysis',
                component: () => import('@/views/dataAnalysis/businessAnalysis/index.vue'),
                icon: 'customerMarket',
            }

        ]
    },
    {
        path: '/setting',
        name: 'menu.setting',
        redirect: '/setting/permission',
        icon: 'menu-setting-icon',
        meta: {
            role: [1]
        },
        children: [
            // 组织与成员管理
            {
                path: 'permission',
                name: 'menu.permission',
                component: () => import('@/views/settings/permission/index.vue'),
                icon: 'customerMarket',
                meta: {
                    role: [1]
                }
            },
            {
                path: 'staff',
                name: 'menu.staffManagement',
                component: () => import('@/views/settings/department/index.vue'),
                icon: 'customerMarket',
                meta: {
                    role: [1]
                }
            }
        ]
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/404/index.vue'),
        hidden: true
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404',
        hidden: true
    }
];
export const asyncRoutes: RouteItem[] = [
    // 系统设置

];
const router = createRouter({
    //https://router.vuejs.org/zh/api/index.html#createwebhashhistory
    history: createWebHistory('/'),
    routes: routes as any
});

router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: any) => {
    const userStore = defineUserStore();
    // const allRoutes = routesModule();
    const roleId = computed(() => {
        return userStore.User?.role_info?.role_id || '';
    });
    // const routerList = allRoutes.routerObj?.routes || [];
    if (to.path === '/404') {
        next();
        return;
    }
    if (!roleId.value) {
        const userInfo = await userStore.getUserInfos();
        if (userInfo?.role_info?.role_id) {
            next();
            return;
        }
        userStore.setPermissionView(false);
        next({ path: '/404', replace: true });
        return;
    }
    if (to.path === '/login') {
        next({ path: '/lead', replace: true });
        return;
    }
    if (['/accounts/management', '/lead/list', '/contact/list', '/business/list'].includes(to.path)) {
        const { fetchUnderList } = useUnderlingAndDistrictCN();
        fetchUnderList();
    }
    const routeRoles = (to?.meta?.role || []) as string[];
    if (!routeRoles.length || routeRoles.includes(roleId.value) || roleId.value === 1) {
        next();
        return;
    }
    next({ path: '/lead', replace: true });
});

export default router;
